/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CarveOutQuote } from './CarveOutQuote';
import {
    CarveOutQuoteFromJSON,
    CarveOutQuoteFromJSONTyped,
    CarveOutQuoteToJSON,
} from './CarveOutQuote';

/**
 * 
 * @export
 * @interface AddCarveOutQuote201Response
 */
export interface AddCarveOutQuote201Response {
    /**
     * 
     * @type {CarveOutQuote}
     * @memberof AddCarveOutQuote201Response
     */
    data?: CarveOutQuote;
}

/**
 * Check if a given object implements the AddCarveOutQuote201Response interface.
 */
export function instanceOfAddCarveOutQuote201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddCarveOutQuote201ResponseFromJSON(json: any): AddCarveOutQuote201Response {
    return AddCarveOutQuote201ResponseFromJSONTyped(json, false);
}

export function AddCarveOutQuote201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCarveOutQuote201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CarveOutQuoteFromJSON(json['data']),
    };
}

export function AddCarveOutQuote201ResponseToJSON(value?: AddCarveOutQuote201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CarveOutQuoteToJSON(value.data),
    };
}

